import axios from "axios";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { baseUrl } from "../../config/baseUrl";
import MultiSelectDropdown from "../edu-users/multi-select-dropdown";
import { Bounce, toast } from "react-toastify";

export const EduCompanyEdit = ({
  userType,
  forceUpdate,
  setForceUpdate,
  activateEduCompanyEdit,
  setActivateEduCompanyEdit,
  companyData,
}) => {
  const { name, description: companyDesc, id } = companyData;
  const [companyName, setCompanyName] = useState(name || "");
  const [description, setDescription] = useState(companyDesc || "");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const patchData = {
      ...(companyName !== name ? { name: companyName } : {}),
      ...(companyDesc !== description ? { description: description } : {}),
    };
    let response;
    try {
      response = await axios(`${baseUrl}/update_company/${id}/`, {
        method: "PATCH",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
        data: { ...patchData },
      });
      if (response?.status === 200) {
        setForceUpdate(!forceUpdate);
        toast.success("Company updated Successfully!!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        let unique = document.getElementById("edu-company-edit");
        unique.click();
        setActivateEduCompanyEdit(false);
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  useEffect(() => {
    if (activateEduCompanyEdit) {
      setCompanyName(name);
      setDescription(companyDesc);
    }
  }, [activateEduCompanyEdit]);

  return (
    <div
      className="modal fade custom-modal users-modal"
      id="edit-company"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">
              {userType === "ADMIN_MANAGER" ? "Modify User" : "Modify Admin"}
            </h5>
            <button
              type="button"
              className="modal-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="edu-company-edit"
              onClick={() => {
                setActivateEduCompanyEdit(false);
              }}
            >
              <i className="fa fa-times" />
            </button>
          </div>
          <div className="modal-body">
            <div className="table modal-table">
              <div className="d-flex flex-column justify-content-center align-items-center gap-3 p-3">
                {/* Row 1 */}
                <div
                  className="w-100 d-flex flex-column flex-wrap gap-3"
                  style={{ maxWidth: "700px" }}
                >
                  <div className="flex-grow-1">
                    <label className="form-label">
                      Company Name <i className="fa fa-star fz-12" />
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Company name"
                      name="company_name"
                      onChange={(e) => setCompanyName(e.target.value)}
                      value={companyName}
                    />
                  </div>

                  <div className="flex-grow-1">
                    <label className="form-label">Description</label>
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Write description here"
                      name="company_description"
                      onChange={(e) => setDescription(e.target.value)}
                      value={description}
                      maxLength="300"
                      rows="5"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-5"
              data-bs-dismiss="modal"
              id="unique"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              type="button"
              className="thm-btn"
              // data-bs-dismiss="modal"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
